import {
  PACK_MODE,
  PICK_MODE,
} from '../../../common/constants/PackingOrderModal.js'
import {PACK_SHIP_PAGE} from '../../../common/constants/Pages.js'
import {
  PluralBlock,
  IfSingle,
  IfPlural,
  Count,
} from '../../../common/components/Plural.js'
import {
  resetPackPanel,
  setupPackPanel,
  updatePackPanelForm,
} from './packPanelActions.js'
import {useSelector} from '../../../store.js'
import {currentPageSelector} from '../../../redux/selectors/ui/index.js'
import Zelect from '../../../common/components/Zelect.js'
import {
  packPanelFormSelector,
  packSortOptionsSelector,
  packWarehouseOptionsSelector,
} from './packPanelSelectors.js'
import Checkbox from '../../../common/components/Checkbox.js'
import Icon from '../../../common/icons/Icon.js'

export default function PackPanelHeader({
  orderNumbers,
  mode,
  verifiedLineCount,
  totalLineCount,
  warehouseFocusID,
}) {
  const sortListByParam = `sortListBy__${mode}`
  const currentPage = useSelector(currentPageSelector)
  const warehouseOptions = useSelector(packWarehouseOptionsSelector)
  const {
    [sortListByParam]: sortListBy,
    includeKitParents,
    containsKits,
  } = useSelector(packPanelFormSelector) || {}
  const sortOptions = useSelector(packSortOptionsSelector)

  if (currentPage === PACK_SHIP_PAGE) {
    return (
      <div className="row padding-top-20 margin-bottom-25">
        <div className="medium-12 columns">
          <ul className="list list--no-style flex--justify margin-bottom-15">
            <li className="fs-02 lh-md inline-block margin-right-5 margin-bottom-0 v-align-middle">
              <span>{verifiedLineCount}</span>/<span>{totalLineCount}</span>{' '}
              Lines {mode === PACK_MODE ? 'Verified' : 'Picked'}
            </li>
            <li className="inline-block margin-bottom-0">
              <button
                className="btn btn--primary btn--primary-ol btn--x-sm  meta-verify-order-modal-reset-button margin-bottom-0"
                type="button"
                title={`Reset the ${
                  mode === PACK_MODE ? 'verified' : 'picked'
                } quantities`}
                onClick={() => resetPackPanel()}
              >
                Reset Lines
              </button>
            </li>
          </ul>
          <div className="flex alert alert--neutral align-items-center">
            <div className="w-35 margin-right-20">
              <Zelect
                id="pick_sort_list_by"
                label="Sort"
                value={sortListBy}
                onChange={(option) =>
                  updatePackPanelForm(
                    {[sortListByParam]: option.value},
                    {stickyProps: [sortListByParam]},
                  )
                }
                options={sortOptions}
                IfSingleSelected={({option}) => `${option.display}`}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="row padding-top-20 margin-bottom-25">
      <div className="medium-12 columns">
        <div className="flex--justify margin-bottom-15">
          <PluralBlock array={orderNumbers}>
            <p className="fs-02 lh-md margin-bottom-0">
              <strong>
                <IfSingle>{orderNumbers[0]}</IfSingle>
                <IfPlural>
                  <Count /> orders
                </IfPlural>
              </strong>
            </p>
          </PluralBlock>
          <ul className="list list--no-style">
            <li className="fs-02 lh-md inline-block margin-right-5 margin-bottom-0">
              <span>{verifiedLineCount}</span>/<span>{totalLineCount}</span>{' '}
              Lines {mode === PACK_MODE ? 'Verified' : 'Picked'}
            </li>
            <li className="inline-block">
              <button
                className="btn btn--link lighter no-underline meta-verify-order-modal-reset-button"
                type="button"
                title={`Reset the ${
                  mode === PACK_MODE ? 'verified' : 'picked'
                } quantities`}
                onClick={() => resetPackPanel()}
              >
                <Icon name="refresh" className="fs-02 lh-md v-align-baseline" />
              </button>
            </li>
          </ul>
        </div>

        <div className="flex alert alert--neutral align-items-center">
          {mode === PICK_MODE && warehouseOptions.length > 2 && (
            <div className="w-35 margin-right-15">
              <Zelect
                label="Warehouse"
                id="warehouse_focus_id"
                value={warehouseFocusID}
                onChange={(option) =>
                  updatePackPanelForm({warehouseFocusID: option.value})
                }
                options={warehouseOptions}
              />
            </div>
          )}
          <div className="w-35 margin-right-20">
            <Zelect
              id="pick_sort_list_by"
              label="Sort"
              value={sortListBy}
              onChange={(option) =>
                updatePackPanelForm(
                  {[sortListByParam]: option.value},
                  {stickyProps: [sortListByParam]},
                )
              }
              options={sortOptions}
              IfSingleSelected={({option}) => `${option.display}`}
            />
          </div>
          {mode === PICK_MODE && containsKits && (
            <div className="margin-top-20">
              <Checkbox
                label="Include Kit Parents"
                className="v-align-middle margin-bottom-0"
                labelClassName="margin-bottom-0 flex align-items-center"
                id="include_kit_parents"
                checked={includeKitParents}
                onChange={(checked) => {
                  updatePackPanelForm(
                    {includeKitParents: checked, isLoading: true},
                    {stickyProps: ['includeKitParents']},
                  )

                  setupPackPanel(orderNumbers)
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
